// src/components/Misiones.js

import React from 'react';
import Card from './Card';
import HabitoCard from './HabitoCard';
import TareaCard from './TareaCard';

function Misiones({ tareas, onCompletarTarea, onCompletarHabito }) {
  const tareasUnicas = tareas.filter(t => t.tipo === 'UNICA' && !t.aprobada);
  const habitos = tareas.filter(t => t.tipo === 'RECURRENTE');

  return (
    <div>
      {/* Sección de Hábitos */}
      {habitos.length > 0 && (
        <div className='mb-12'>
          <h2 className="text-3xl font-bold text-gray-700 mb-6">Tus Hábitos Semanales</h2>
          <div className="space-y-6">
            {habitos.map(habito => (
              <HabitoCard key={habito.id} tarea={habito} onCompletarHabito={onCompletarHabito} />
            ))}
          </div>
        </div>
      )}

      {/* Sección de Tareas Únicas */}
      <div>
        <h2 className="text-3xl font-bold text-gray-700 mb-6">Tus Misiones Únicas</h2>
        <div className="space-y-6">
          {tareasUnicas.length > 0 ? (
            tareasUnicas.map(tarea => (
              <TareaCard key={tarea.id} tarea={tarea} onCompletar={onCompletarTarea} />
            ))
          ) : (
            <Card>
              <p className="text-gray-500 text-center py-4">¡Felicidades! No tienes misiones únicas pendientes.</p>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
}

export default Misiones;